import { buildSearchFilterProps, sortStringColumn } from '../../../../../components/tables/utils'

export const buildUsersTableColumns = () => [
  {
    title: 'First Name',
    dataIndex: 'firstName',
    sorter: sortStringColumn({ dataIndex: 'firstName' }),
    ...buildSearchFilterProps({ dataIndex: 'firstName' }),
  },
  {
    title: 'Surname',
    dataIndex: 'surname',
    sorter: sortStringColumn({ dataIndex: 'surname' }),
    ...buildSearchFilterProps({ dataIndex: 'surname' }),
  },
  {
    title: 'E-mail',
    dataIndex: 'email',
    sorter: sortStringColumn({ dataIndex: 'email' }),
    ...buildSearchFilterProps({ dataIndex: 'email' }),
  },
  {
    title: 'Issuer',
    dataIndex: 'addedBy',
    render: (addedBy) => addedBy?.name || '-',
  },
]
